
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { PreRenderProps } from '@/pages/_app';
import { getViewDefinition } from '@/ssr/view-definition-page-query';
import { fetchDataAndHandleErrors } from '@/utils/ssr-utils';
import { Spinner } from '@/components/shared';
// @ts-ignore: federated module
const PDP = dynamic(() => import('beautyFrontendPlp/Pdp'), { ssr: false, loading: () => <Spinner /> });

export const getServerSideProps: GetServerSideProps<PreRenderProps> = async (context) => {
  const data = await fetchDataAndHandleErrors(context, getViewDefinition, undefined);
  return { props: data };
};

const SDMRoutes = (props: any) => {
  const router = useRouter();
  const isPdpPage = router.query.slug?.[1] === 'p';
  return isPdpPage ? <PDP /> : <AuthoredPageRoutes {...props} />;
};

export default SDMRoutes;
